


















import { Component, Vue } from "vue-property-decorator";
import CourseForm from "@/components/courses/CourseForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { Course as ICourse } from "@/api-v2/course/models";
import CourseFormV2 from "@/components/courses/CourseV2/CourseFormV2.vue";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import { CourseDocumentInfoEdit as ICourseDocumentInfoEdit } from "@/api-v2/course-document-info/models";
import { courseApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import CourseInfoForm from "@/components/courses/CourseV2/CourseInfoForm.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CourseDocumentFrom from "@/components/courses/CourseV2/CourseDocumentFrom.vue";

@Component({
  components: {
    CourseDocumentFrom,
    CustomButton,
    CourseInfoForm,
    CPageButtons,
    CourseFormV2,
    CField,
    CBlock,
    CPage,
    CBreadCrumbs,
    CourseForm
  }
})
export default class CourseDocumentInfoCreate extends Vue {
  course!: ICourse;
  isLoading: boolean = false;
  documentForm: ICourseDocumentInfoEdit = {};
  data() {
    return {
      course: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "courses" },
        label: this.$tc(this.$translate.Courses)
      },
      {
        to: { name: "course", params: { id: this.course.id } },
        label: this.course.title
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async getCourse() {
    await courseApi.Course.getCourse(this.$route.params.id)
      .then(res => {
        this.course = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async getDocumentInfo() {
    await courseApi.CourseDocumentInfo.getCourseDocumentInfo(
      this.$route.params.id
    )
      .then(res => {
        this.documentForm.validityOfDocument =
          res.data.validityOfDocument ?? this.documentForm.validityOfDocument;

        this.documentForm.documentTypeId =
          res.data?.documentType?.id ?? this.documentForm.documentTypeId;

        this.documentForm.qualification =
          res.data?.qualification ?? this.documentForm.qualification;

        this.documentForm.specialtyId =
          res.data?.specialty?.id ?? this.documentForm.specialtyId;

        this.documentForm.programId =
          res.data?.program?.id ?? this.documentForm.programId;

        this.documentForm.activityId =
          res.data?.activity?.id ?? this.documentForm.activityId;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  async submit() {
    if (await this.$store.dispatch("validate/CHECK_VALIDATIONS")) return;
    this.isLoading = true;
    courseApi.CourseDocumentInfo.editCourseDocumentInfo(
      this.$route.params.id,
      this.documentForm
    )
      .then(() => {
        this.$router.push({
          name: "course",
          params: {
            id: this.$route.params.id
          }
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  async created() {
    this.isLoading = true;
    await this.getCourse();
    await this.getDocumentInfo();
    this.isLoading = false;
  }
}
